<template>
    <div>
        <div class="flex justify-center w-full">
            <custom-tooltip bottom border>
                <app-button icon circle @click="openNewFilter">
                    <img
                        src="@/assets/images/filter.svg"
                        height="15"
                        width="15"
                        alt="reload img"
                    />
                </app-button>

                <template #tooltip> Modificar filtros de búsqueda </template>
            </custom-tooltip>
        </div>
        <div class="flex flex-col mt-1">
            <dates-range-filter
                v-if="activeFilters.includes('dateRange')"
                v-model="dateRange"
                @change="applyFilter"
            />
            <time-ago-filter
                v-if="activeFilters.includes('timeAgo')"
                v-model="timeAgo"
                @change="applyFilter"
            />
        </div>

        <app-dialog v-model="isOpenModal" size="lg" @close="pushNewFilter">
            <template #header>
                <div class="flex items-center justify-between gap-4">
                    <h3 class="text-base font-semibold text-theme-base">
                        Selecciona los filtros {{ label }}
                    </h3>

                    <app-button
                        :disabled="!activeFilters.length"
                        @click="isOpenModal = false"
                    >
                        ✔️ Aplicar filtros ({{ activeFilters.length }})
                    </app-button>
                </div>
            </template>
            <cards-selector
                v-model="activeFilters"
                :base="$data.$baseFilters"
            />
        </app-dialog>
    </div>
</template>

<script>
import { timeFilters } from "@/common/fields/filters-query";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardsSelector.vue";

export default {
    name: "TimeFilters",
    components: {
        AppDialog,
        CardsSelector,
        TimeAgoFilter: () => import("@/components/utils/TimeAgoFilter.vue"),
        DatesRangeFilter: () =>
            import("@/components/utils/DatesRangeFilter.vue")
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => ({}),
            type: Object,
            require: true
        },
        label: {
            default: () => "",
            type: String,
            require: false
        }
    },
    data: () => ({
        activeFilters: [],
        isOpenModal: false,
        dateRange: {},
        timeAgo: { timeScale: "agoDays", timeValue: 7 },
        $baseFilters: timeFilters
    }),
    watch: {
        filters() {
            this.applyFilter();
        }
    },
    mounted() {
        const timeKeys = ["agoDays", "agoMonths"];
        const foundKey = timeKeys.find((key) => key in this.itemsCurrent);

        if (foundKey) {
            this.activeFilters.push("timeAgo");
            this.timeAgo = {
                timeScale: foundKey,
                timeValue: this.itemsCurrent[foundKey]
            };
            return;
        }
        if ("begin" in this.itemsCurrent && "end" in this.itemsCurrent) {
            this.activeFilters.push("dateRange");
            this.dateRange = {
                end: this.itemsCurrent.end,
                begin: this.itemsCurrent.begin
            };
            return;
        }
    },
    methods: {
        openNewFilter() {
            this.isOpenModal = true;
        },
        pushNewFilter() {
            this.applyFilter();
        },
        applyFilter() {
            this.$emit("change", {
                ...{
                    ...(this.activeFilters.includes("dateRange")
                        ? this.dateRange
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("timeAgo")
                        ? {
                              [this.timeAgo.timeScale]: this.timeAgo.timeValue
                          }
                        : null)
                }
            });
        }
    }
};
</script>
